<template>
  <div>
    <kst-input field="CategoryID" :data="data" :catalog="Catalog" :options="categoryOption" />
    <kst-input field="Name" :data="data" :catalog="Catalog" />
  </div>
</template>
<script>
import Catalog from "../ExpenseSubCategoryCatalog.js";

export default {
  props: {
    data: Object,
    categoryOption: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>